;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();export const usageTrackingQueryKeys = {
	all: ["usage-tracking"] as const,
	organization: ({
		endDate,
		startDate,
	}: {
		endDate: string;
		startDate: string;
	}) =>
		[
			...usageTrackingQueryKeys.all,
			"organization",
			startDate,
			endDate,
		] as const,
};
